import { SignInPageStaff } from '@components/log_in/SignInPageStaff'
import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { handleAuthRedirect, parentAuthRoutesParamSchema } from './route'

const defaultValues = {
    returnUrl: '/home',
}

export const Route = createFileRoute('/_nolayout/_auth/sign-in')({
    component: SignInPageStaff,
    validateSearch: zodValidator(parentAuthRoutesParamSchema),
    search: {
        middlewares: [stripSearchParams(defaultValues)]
    },
    beforeLoad: handleAuthRedirect,
})
